module.exports = __webpack_public_path__ + "static/media/да.89194cba.mp3";